module.exports = __webpack_public_path__ + "static/media/warning.2e28f262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warning.png
// module id = 807
// module chunks = 2